import React from 'react'
import './Card.css'
import ViewMoreButton from 'src/components/Tables/ViewMoreButton'

type CardProps = {
  title: string
  viewMorePath?: string
  description?: string
  children?: React.ReactNode
}

const Card: React.FC<CardProps> = ({ title, description, viewMorePath, children }) => {
  return (
    <div className='card-container'>
      <div className='card-header'>
        <h4 className='card-title'>{title}</h4>
        {viewMorePath && <ViewMoreButton path={viewMorePath} />}
      </div>
      {
        description && (
          <h1 className='card-description'>{description}</h1>
        )
      }
      {children}
    </div>
  )
}

export default Card
